exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalog-iframe {\n    width: 100vw;\n    height: 100vh;\n    min-height: 1000px;\n}\n\nform {\n    margin-top: 50px;\n}\n\n.btn-default {\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.error {\n    font-size: 30px;\n    color: #ff0033;\n    position: absolute;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_0264da94/src/app/catalog/catalog.component.css
// module id = ../../../../../src/app/catalog/catalog.component.css
// module chunks = main